module.exports = __webpack_public_path__ + "static/media/gps_check_in.ed3c7998.png";